import { useLocaleCode } from '../../location/LocationConnectors';
import { stringsFor } from '../../location/locales';

export { useLocaleCode };

export const getFeatureTranslations = localeCode => stringsFor(localeCode).shingles.features;

const useFeatureTranslations = () => {
  const currentLocale = useLocaleCode();

  return getFeatureTranslations(currentLocale);
};

export default useFeatureTranslations;
